import { render } from "./DropDownListPatTipoBem.vue?vue&type=template&id=7a36f6b9&ts=true"
import script from "./DropDownListPatTipoBem.vue?vue&type=script&lang=ts"
export * from "./DropDownListPatTipoBem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__